<template>
    <div class="stay confirmation">
        <div class="container">
            <div class="row">
                <div class="col-24 ">
                    <div class="page-intro">
                        <h1>Congrats</h1>
                        <h2>Your stay is booked!</h2>
                        <p>
                            We look forward to welcoming you to Rockliffe Hall, and have sent a confirmation of your booking to the email address provided.
                        </p>
                        <span class="confirmation-number">Confirmation Number: <strong>{{booking.legs[0].confirmationNumber}}</strong></span>
                    </div>

                    <div class="container mb-4 d-print-none">
                        <div class="row justify-content-center">
                            <div class="col-xl-12  text-center">
                                <a class="lnk-print mr-2"
                                   v-on:click="printWindow();">Print Confirmation</a>
                                <a class="lnk-email ml-2"
                                   v-on:click="toggleSendToFriend()">Send to a friend</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="sendToFriend" class="row justify-content-center ">
                <div class="col-xl-12  mb-5">
                    <Form @submit="onSendEmail" :validation-schema="schema">

                        <div class=" p-5 bg-white has-shadow ">
                            <h3>Send to a friend</h3>
                            <p>Enter an email address below and we'll send a copy of your confirmation.</p>

                            <div v-if="!isEmailLoading">
                                <div class="form-group row  flex-row g-0">
                                    <div class="col-xl-16 mb-3 mb-xl-0">

                                        <Field name="emailAddress" class="form-control" placeholder="Email address"></Field>

                                    </div>
                                    <button class="btn btn--gold col-12 col-xl-8" type="submit">Send</button>
                                </div>
                                <div class="form-group row  flex-row g-0">
                                    <div class="col-xl-16 mb-3 mb-xl-0">
                                        <ErrorMessage name="emailAddress" class="error-message" />

                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <div class="form-group row  flex-row g-0">
                                    <div class="col-xl-16 mb-3 mb-xl-0">
                                        <div class="d-flex justify-content-center">
                                            <loader></loader>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Form>
                </div>
            </div>

            <div class="row justify-content-center">
                <div class="current-action"><span class="action">Payment &amp; Bills</span></div>
                <div class="d-flex flex-row">
                    <to-pay v-bind:isTodayPayment="true"></to-pay>
                    <to-pay v-bind:isTodayPayment="false"></to-pay>
                </div>
            </div>

            <div class="row justify-content-center">
                <div class="current-action">
                    <span class="action">Your booking details</span>
                </div>
                <div v-if="createdAccount != null" class="row mb-4 d-flex justify-content-center">
                    <div class="col-lg-12">

                        <div class="bg-white w-100 p-4 position-relative">

                            <div v-if="createdAccount">
                                <info-box v-bind:type="'success'">
                                    <template v-slot:body>
                                        <div class="d-flex justify-content-between">
                                            <span class="heading">
                                                Your Rockliffe Hall account was created successfully.
                                            </span>

                                            <a v-if="!isAuthenticated" href="/account/#/login"
                                               class="account_login">
                                                Login
                                            </a>

                                        </div>
                                        <div>
                                            <p>
                                                You can now login and review or amend your booking.
                                            </p>

                                        </div>
                                    </template>
                                </info-box>

                            </div>
                            <div v-else>
                                <info-box v-bind:type="'error'">
                                    <template v-slot:body>
                                        <span class="heading">
                                            We were unable to create your Rockliffe Hall account.
                                        </span>


                                    </template>
                                </info-box>
                            </div>

                        </div>
                    </div>
                </div>

                <div class="row mb-4 d-flex justify-content-center">
                    <div class="col-24">
                        <div class="row mb-4 d-flex justify-content-center">
                            <div v-for="leg in booking.legs"
                                 v-bind:key="leg.leg"
                                 class="col-lg-12">
                                <room-booking-summary v-bind:leg="leg.leg"
                                                      v-bind:isConfirmationPage="true"
                                                      v-bind:isPastTense="true"
                                                      v-bind:allowEdit="false"></room-booking-summary>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <div class="d-print-none">
            <actions-bar>
                <template v-slot:actions>
                    <div class="row">
                        <div class="col-24 d-flex justify-content-center">

                            <a href="/" class="btn btn--slate-blue">Rockliffe Home</a>
                            <a href="/account/#bookings/stay"
                               v-if="isAuthenticated"
                               class="btn btn--slate-blue">Account </a>
                        </div>

                    </div>
                </template>
            </actions-bar>
        </div>
    </div>
</template>
<script>

    import { Field, Form, ErrorMessage } from "vee-validate";
    import * as yup from "yup";


    import ActionsBar from '@/shared/components/ActionsBar.vue';

    import CurrentAction from '../components/CurrentAction.vue';
    import RoomBookingSummary from '../components/RoomBookingSummary.vue';
    import ToPay from '../components/ToPay.vue';
    import Loader from '@/shared/components/Loader.vue';

    import { store } from '../store/index';
    import { accountStore } from '@/account/store/index';


    import stayapi from '@/shared/api/stay';

    import InfoBox from '@/shared/components/InfoBox.vue';

    export default {
        name: 'StayConfirmation',

        components: {
            ActionsBar,
            ToPay,
            CurrentAction,
            RoomBookingSummary,
            InfoBox,
            Loader,
            Field,
            Form,
            ErrorMessage,
        },
        computed: {
            session() {
                return store.getters.session
            },
            booking() {
                return store.getters.booking;
            },
            isAuthenticated() {
                return accountStore.getters.isAuthenticated;
            },
            createdAccount() {
                let result = null;
                let session = this.session;
                if (session.accountCreateStatus !== undefined) {
                    if (session.accountCreateStatus.attempted) {
                        if (session.accountCreateStatus.failed) {
                            return false;
                        }
                        return true;
                    }
                }

                return result;
            }
        },
        data() {

            const schema = yup.object().shape({
                emailAddress: yup.string().required().email().label("Email address"),
            });



            return {
                schema,
                sendToFriend: false,
                emailAddress: null,
                isEmailLoading: false,
            }

        },
        mounted() {
            this.track();
        },
        methods: {
            onSendEmail(values) {

                this.isEmailLoading = true;

                let payload = {
                    confirmation: this.booking.legs[0].confirmationNumber,
                    emailAddress: values.emailAddress
                }


                let so = this;
                stayapi.sendEmail(payload, t => {
                    this.isEmailLoading = false;
                },
                    f => {
                        this.isEmailLoading = false;
                    });
            },
            track() {
                let items = [];
                let total = 0;
                for (let li in this.booking.legs) {

                    let leg = this.booking.legs[li];
                    items.push({
                        "item_id": leg.room.PMSCode + '-' + leg.rate.availableRate.RateCode,
                        "item_name": leg.room.DisplayName + ' - ' + leg.rate.availableRate.RateCode,
                        "item_brand": "Rockliffe Hall",
                        "quantity": 1,
                        "price": leg.rate.availableRate.Amount,
                        "item_category": "Room/Rate"
                    })



                    if (leg.includedPackages !== undefined && leg.includedPackages != null && leg.includedPackages.length) {
                        for (let pi = 0; pi < leg.includedPackages.length; pi++) {
                            let pkge = leg.includedPackages[pi];

                            items.push({
                                "item_id": pkge.Code,
                                "item_name": pkge.Code,
                                "item_brand": "Rockliffe Hall",
                                "quantity": +(pkge.QuantityRequired),
                                "price": +(pkge.UnitPrice),
                                "item_category": "Included Package"
                            })
                            total += +(pkge.UnitPrice) * +(pkge.QuantityRequired);
                        }


                    }


                    if (leg.packages !== undefined && leg.packages != null && leg.packages.length) {
                        for (let pIndex = 0; pIndex < leg.packages.length; pIndex++) {
                            let pkge2 = leg.packages[pIndex];

                            items.push({
                                "item_id": pkge2.item.availability.Code,
                                "item_name": pkge2.item.content.DisplayName,
                                "item_brand": "Rockliffe Hall",
                                "quantity": +(pkge2.quantity),
                                "price": +(pkge2.item.availability.Amount),
                                "item_category": "Package"
                            })
                            total += +(pkge2.item.availability.Amount) * +(pkge2.quantity);
                        }


                    }



                    total += +(leg.rate.availableRate.Amount);
                };


                this.$gtag.purchase({
                    "transaction_id": this.booking.legs[0].confirmationNumber,
                    "affiliation": "Rockliffe Hall Stay Booking",
                    "value": total,
                    "currency": this.booking.legs[0].rate.availableRate.Currency,
                    "items": items
                })

                if (this.$gtm.enabled()) {

                    window.dataLayer?.push({
                        'pageURL': '/stay/stay/confirmation',
                        'event': 'purchase',
                        'transaction_id': this.booking.legs[0].confirmationNumber,
                        'value': total,
                        'curency': this.booking.legs[0].rate.availableRate.Currency,
                        'ecommerce': {
                            'items': items
                        }
                    });
                }





            },

            printWindow: function () {
                window.print();
            },
            toggleSendToFriend: function () {
                this.sendToFriend = !this.sendToFriend;
            },
            sendEmail: function () {

            }
        }
    }
</script>

<style>
    .stay.confirmation .page-intro h1 {
        font-size: 180px !important;
        font-family: 'heatsregular';
        text-transform: none;
    }

    .stay.confirmation .account_login {
        font-weight: bold;
    }

        .stay.confirmation .account_login:hover {
            text-decoration: underline;
        }
</style>

